import {
  ChatSmileIcon,
  ChatMessageIcon,
  CalendarIcon,
  ReceptionistIcon,
  LeadQualificationIcon,
  HeadphoneIcon,
  HomeServicesIcon,
  RestorationIcon,
  PlumbingIcon,
  ElectricalIcon,
  HvacIcon,
  ConstructionIcon,
  RemodelingIcon,
  LandscapingIcon,
  ServiceTitanIcon,
  PipeDriveIcon,
  SalesForceIcon,
  HouseCallProIcon,
  HubspotIcon,
  RoofingIcon,
  ServiceFusionIcon,
  WorkizIcon,
  QuickbooksIcon,
  ZapierIntegrationIcon,
  JobberIcon,
  EncirlceIcon,
  FieldPulseIcon,
  Improveit360Icon,
} from "@/atoms/Icons";

export const servicesData = [
  {
    title: "24/7 Live Answering",
    icon: HeadphoneIcon,
    description:
      "Extend your reputation with real people answering every call.",
    href: "/answering-services",
  },
  {
    title: "Appointment Scheduling",
    icon: CalendarIcon,
    description: "Estimates and work booked directly into your calendar.",
    href: "/answering-services/appointment-setting",
  },
  {
    title: "Lead Qualification",
    icon: LeadQualificationIcon,
    description:
      "Focus on the job while your leads are screened and qualified.",
    href: "/answering-services/lead-capture",
  },
  {
    title: "Live Chat",
    icon: ChatMessageIcon,
    description:
      "Build connections and capture leads through your website 24/7.",
    href: "/live-chat",
  },
  {
    title: "After Hours Answering",
    icon: ReceptionistIcon,
    description:
      "Available for your customers when emergencies happen, day and night.",
    href: "/answering-services/after-hours-answering",
  },
  {
    title: "Bilingual Answering",
    icon: ChatSmileIcon,
    description:
      "Expand your customer reach with English and Spanish receptionists.",
    href: "/answering-services/bilingual-answering",
  },
];

export const industriesData = [
  {
    title: "HVAC",
    icon: HvacIcon,
    href: "/hvac-answering-service",
  },
  {
    title: "Home Services",
    icon: HomeServicesIcon,
    href: "/home-services",
  },
  {
    title: "Restoration",
    icon: RestorationIcon,
    href: "/restoration-answering-service",
  },
  {
    title: "Roofing",
    icon: RoofingIcon,
    href: "/industries/roofing",
  },
  {
    title: "Plumbing",
    icon: PlumbingIcon,
    href: "/plumbing-answering-service",
  },
  {
    title: "Electrical",
    icon: ElectricalIcon,
    href: "/electrician-answering-service",
  },
  {
    title: "Construction",
    icon: ConstructionIcon,
    href: "/industries/construction",
  },
  {
    title: "Remodeling",
    icon: RemodelingIcon,
    href: "/remodeling-answering-service",
  },
  {
    title: "Landscaping",
    icon: LandscapingIcon,
    href: "/landscaping-answering-service",
  },
];

export const toolsData = [
  {
    title: "Mobile App",
    description: "Stay connected throughout your day while you're on the job.",
    href: "/app",
  },
  {
    title: "Appointment Scheduling",
    description: "Estimates and jobs booked directly into your workflow.",
    href: "/answering-services/appointment-setting",
  },
  {
    title: "Live Chat",
    description: "Connect and convert leads through your website and Facebook.",
    href: "/live-chat",
  },
  {
    title: "Business Phone Line",
    description: "Call and text customers from a dedicated business number.",
    href: "/business-phone-line",
  },
];

export const integrationsData = [
  {
    title: "ServiceTitan",
    href: "/integrations/servicetitan",
    icon: ServiceTitanIcon,
  },
  {
    title: "Workiz",
    href: "/integrations/workiz",
    icon: WorkizIcon,
  },
  {
    title: "Quickbooks",
    href: "/integrations/quickbooks",
    icon: QuickbooksIcon,
  },
  {
    title: "Jobber",
    href: "/integrations/jobber",
    icon: JobberIcon,
  },
  {
    title: "Encirlce",
    href: "/integrations/encircle",
    icon: EncirlceIcon,
  },
  {
    title: "Zapier",
    href: "/integrations/zapier",
    icon: ZapierIntegrationIcon,
  },
  {
    title: "Housecall Pro",
    href: "/integrations/housecallpro",
    icon: HouseCallProIcon,
  },
  {
    title: "FieldPulse",
    href: "/integrations/fieldpulse",
    icon: FieldPulseIcon,
  },
  {
    title: "SalesForce",
    href: "/integrations/salesforce",
    icon: SalesForceIcon,
  },
  {
    title: "Service Fusion",
    href: "/integrations",
    icon: ServiceFusionIcon,
  },
  {
    title: "Improveit360",
    href: "/integrations",
    icon: Improveit360Icon,
  },
  {
    title: "Hubspot",
    href: "/integrations",
    icon: HubspotIcon,
  },
];

export const whyData = [
  {
    title: "Partners",
    href: "http://www.answerforce.com/partners/",
    description: "Explore service partners and trade associations.",
  },
  {
    title: "Case Studies",
    href: "/case-studies",
    description: "The results speak for themselves - hear from service pros.",
  },
  {
    title: "Pledge People, Not Bots",
    href: "/pledge-people-not-bots",
    description: "Powering the service industry with real people 24/7.",
  },
  {
    title: "Giving Back",
    href: "/giving-back",
    description:
      "We plant a tree for every customer, every month. You Grow. We Plant.",
  },
  {
    title: "Grow your brand",
    href: "/grow-your-brand",
    description: "Build relationships that last. Build your story, your way.",
  },
];

export const meganavFooterData = [
  {
    title: "24/7 Solutions for Service Professionals",
    description:
      "Always on call to support your existing clients and capture new leads.",
    link: "/services",
    buttonText: "See all services",
  },
  {
    title: "Industries",
    description:
      "Built for all types of residential and commercial service businesses.",
    link: "/industries",
    buttonText: "See all industries",
  },
  {
    title: "Tools",
    description: "Powerful tools built for growing service businesses.",
    link: "/tools",
    buttonText: "See all tools",
  },
  {
    title: "Integrations",
    description: "Integrate with the tools you already know and love.",
    link: "/integrations",
    buttonText: "See all integrations",
  },
  {
    title: "Why AnswerForce",
    description: "Top-rated by home and field service professionals.",
    link: "/why",
    buttonText: "Learn more",
  },
];
